import keyMirror from 'react-utils/keyMirror';
export const COMM_METHODS_MODAL_TYPES = keyMirror({
  ASSIGNABLE: null,
  UNASSIGNABLE: null
});